// material-ui
import { Card, CardContent, Grid } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

// ==============================|| SKELETON - EARNING CARD ||============================== //
const PlanCardSkeleton = () => (
    <>
        <Grid item>
            <Card className="card-wrapper">
                <CardContent>
                    <Skeleton variant="rectangular" height={600} width={300} />
                </CardContent>
            </Card>
        </Grid>
        <Grid item>
            <Card className="card-wrapper">
                <CardContent>
                    <Skeleton variant="rectangular" height={600} width={300} />
                </CardContent>
            </Card>
        </Grid>
        <Grid item>
            <Card className="card-wrapper">
                <CardContent>
                    <Skeleton variant="rectangular" height={250} width={300} style={{ marginBottom: 16 }} />
                    <Skeleton variant="rectangular" height={15} width={300} style={{ marginBottom: 16 }} />
                    <Skeleton variant="rectangular" height={15} width={300} style={{ marginBottom: 16 }} />
                    <Skeleton variant="rectangular" height={15} width={300} style={{ marginBottom: 16 }} />
                    <Skeleton variant="rectangular" height={15} width={300} style={{ marginBottom: 16 }} />
                    <Skeleton variant="rectangular" height={15} width={300} style={{ marginBottom: 16 }} />
                    <Skeleton variant="rectangular" height={15} width={300} style={{ marginBottom: 16 }} />
                    <Skeleton variant="rectangular" height={15} width={300} style={{ marginBottom: 16 }} />
                    <Skeleton variant="rectangular" height={15} width={300} style={{ marginBottom: 16 }} />
                    <Skeleton variant="rectangular" height={15} width={300} style={{ marginBottom: 16 }} />
                    <Skeleton variant="rectangular" height={15} width={300} />
                </CardContent>
            </Card>
        </Grid>
    </>
);

export default PlanCardSkeleton;
